import { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { NotificationProps } from "../../../@types/components/notifications.types";
import { ListItem, ListItemAvatar, ListItemText, Avatar } from "@material-ui/core";

import { NOTIFICATION_TYPE } from "../../../constants/notification/notificationType";
import timeAgo from "../../../utils/commonFunctions/dateDifferenceCalculator";
import ReactHTMLParser from "react-html-parser";

const Notification = ({ notification, key }: NotificationProps) => {
	const navigate = useNavigate();
	const iconType = useRef({
		[NOTIFICATION_TYPE.super_admin_sign_up]: "fa-sharp fa-solid fa-user-gear",
		[NOTIFICATION_TYPE.creation]: "fa-sharp fa-solid fa-user-plus",
		[NOTIFICATION_TYPE.registration]: "fa-sharp fa-solid fa-user-check",
		[NOTIFICATION_TYPE.edit]: "fa-sharp fa-solid fa-user-pen",
		[NOTIFICATION_TYPE.member_chat_support]: "fa-sharp fa-solid fa-user-headset",
		[NOTIFICATION_TYPE.employer_chat_support]: "fa-sharp fa-solid fa-headset",
		[NOTIFICATION_TYPE.blogs]: "fa-solid fa-laptop-medical",
		[NOTIFICATION_TYPE.announcements]: "fa-sharp fa-solid fa-bullhorn",
		[NOTIFICATION_TYPE.statement_of_understanding]: "fa-sharp fa-solid fa-building-shield",
		[NOTIFICATION_TYPE.registration_help]: "fa-sharp fa-solid fa-hands-holding-child",
		[NOTIFICATION_TYPE.approval]: "fa-sharp fa-solid fa-thumbs-up",
		[NOTIFICATION_TYPE.plan_creation]: "fa-sharp fa-solid fa-notes-medical",
		[NOTIFICATION_TYPE.open_enrollment]: "fa-solid fa-envelope-open-text",
		[NOTIFICATION_TYPE.enrollment_submission]: "fa-solid fa-hand-holding-medical",
		[NOTIFICATION_TYPE.terminate]: "fa-solid fa-person-circle-xmark",
		[NOTIFICATION_TYPE.reinstate]: "fa-solid fa-person-walking-luggage",
		[NOTIFICATION_TYPE.rehire]: "fa-solid fa-person-arrow-up-from-line",
		[NOTIFICATION_TYPE.enroller_action]: "fa-sharp fa-solid fa-arrow-up-9-1"
	});
	const content = notification.text;

	const handleNotificationClick = useCallback(
		(type: string, data: any) => {
			let pathname = null,
				key = null,
				payload = null;
			if (
				type === NOTIFICATION_TYPE.registration ||
				type === NOTIFICATION_TYPE.creation ||
				type === NOTIFICATION_TYPE.approval ||
				type === NOTIFICATION_TYPE.member_chat_support ||
				type === NOTIFICATION_TYPE.employer_chat_support
			) {
				pathname = "/user-information";
				key = "user_id";
				payload = data._id;
			} else if (
				type === NOTIFICATION_TYPE.statement_of_understanding ||
				type === NOTIFICATION_TYPE.registration_help
			) {
				pathname = "/upload-administration";
			} else if (type === NOTIFICATION_TYPE.blogs) {
				pathname = "/health-link";
				payload = data;
				key = "health_link";
			} else if (type === NOTIFICATION_TYPE.announcements) {
				pathname = `/announcements/edit?id=${data._id}&&new=false`;
			}
			if (pathname && key) {
				navigate(pathname, { [key]: payload });
				window.location.reload();
			}
		},
		[navigate]
	);

	return (
		<ListItem
			button
			key={key}
			onClick={() => handleNotificationClick(notification.type, notification.data)}
			className="notification"
		>
			<ListItemAvatar>
				<Avatar className="list-avatar">
					<i className={iconType.current[notification.type]} style={{ fontSize: "16px" }}></i>
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				className="list-item-text"
				primary={ReactHTMLParser(content)}
				secondary={timeAgo(notification.time)}
			/>
		</ListItem>
	);
};

export default Notification;
